import React from 'react';

const Cookies = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.14289 16.4999C8.85297 16.4999 9.42861 15.9243 9.42861 15.2142C9.42861 14.5041 8.85297 13.9285 8.14289 13.9285C7.43281 13.9285 6.85718 14.5041 6.85718 15.2142C6.85718 15.9243 7.43281 16.4999 8.14289 16.4999Z'
        fill='black'
      />
      <path
        d='M16.4998 15.8571C17.2099 15.8571 17.7855 15.2815 17.7855 14.5714C17.7855 13.8613 17.2099 13.2857 16.4998 13.2857C15.7897 13.2857 15.2141 13.8613 15.2141 14.5714C15.2141 15.2815 15.7897 15.8571 16.4998 15.8571Z'
        fill='black'
      />
      <path
        d='M10.0716 9.42858C10.7817 9.42858 11.3573 8.85294 11.3573 8.14286C11.3573 7.43278 10.7817 6.85715 10.0716 6.85715C9.36152 6.85715 8.78589 7.43278 8.78589 8.14286C8.78589 8.85294 9.36152 9.42858 10.0716 9.42858Z'
        fill='black'
      />
      <path
        d='M10.7141 12C11.0692 12 11.357 11.7122 11.357 11.3572C11.357 11.0021 11.0692 10.7143 10.7141 10.7143C10.3591 10.7143 10.0713 11.0021 10.0713 11.3572C10.0713 11.7122 10.3591 12 10.7141 12Z'
        fill='black'
      />
      <path
        d='M16.4998 6.21428C17.2099 6.21428 17.7855 5.63865 17.7855 4.92857C17.7855 4.21849 17.2099 3.64285 16.4998 3.64285C15.7897 3.64285 15.2141 4.21849 15.2141 4.92857C15.2141 5.63865 15.7897 6.21428 16.4998 6.21428Z'
        fill='black'
      />
      <path
        d='M20.357 4.28571C20.712 4.28571 20.9998 3.9979 20.9998 3.64286C20.9998 3.28782 20.712 3 20.357 3C20.0019 3 19.7141 3.28782 19.7141 3.64286C19.7141 3.9979 20.0019 4.28571 20.357 4.28571Z'
        fill='black'
      />
      <path
        d='M12 17.1429C12.3551 17.1429 12.6429 16.855 12.6429 16.5C12.6429 16.145 12.3551 15.8571 12 15.8571C11.645 15.8571 11.3572 16.145 11.3572 16.5C11.3572 16.855 11.645 17.1429 12 17.1429Z'
        fill='black'
      />
      <path
        d='M12 21C7.05 21 3 16.95 3 12C3 7.05 7.05 3 12 3C12.0643 3 12.1286 3 12.1929 3L13.0929 3.06429L12.9 3.83571C12.8357 4.09286 12.7714 4.41429 12.7714 4.67143C12.7714 6.47143 14.1857 7.88571 15.9857 7.88571C16.6286 7.88571 17.2714 7.69286 17.85 7.30714L18.6857 8.27143C18.4286 8.52857 18.3 8.85 18.3 9.17143C18.3 10.0071 19.1357 10.7143 20.0357 10.3929L20.8071 10.0714L20.9357 10.9071C21 11.2929 21 11.6786 21 12C21 16.95 16.95 21 12 21ZM11.55 4.28571C7.5 4.54286 4.28571 7.88571 4.28571 12C4.28571 16.2429 7.75714 19.7143 12 19.7143C16.2429 19.7143 19.7143 16.2429 19.7143 12C19.7143 11.9357 19.7143 11.8071 19.7143 11.7429C18.2357 11.8071 17.0143 10.65 17.0143 9.17143C17.0143 9.10714 17.0143 9.10714 17.0143 9.04286C16.6929 9.10714 16.3714 9.17143 15.9857 9.17143C13.4786 9.17143 11.4857 7.17857 11.4857 4.67143C11.4857 4.54286 11.4857 4.41429 11.55 4.28571Z'
        fill='black'
      />
    </svg>
  );
};

export default Cookies;
